import { createSelector } from '@reduxjs/toolkit';
import { prop } from 'ramda';

export const selectAuth = (state) => state.auth;
export const selectAuthError = createSelector(selectAuth, prop('error'));
export const selectAuthLoading = createSelector(selectAuth, prop('isLoading'));
export const selectAuthMfaError = createSelector(selectAuth, prop('mfaError'));
